<template>
  <div>
    <v-row class="px-3 py-1 s-header">
      <v-col>
        <div class="">
          <span class="text--secondary">Showing</span> 1 - {{ limit }}
          <span class="text--secondary">of</span> {{ totalCount }}
          <span class="text--secondary">results</span>
        </div>
        <!-- <div class="text--disabled caption">Last updated at 6:30 PM IST</div> -->
      </v-col>
      <v-col class="d-none d-sm-flex flex-row-reverse">
        <!-- <v-btn outlined disabled small color="primary" class="ml-2" @click="exportFn()">
          <v-icon small>mdi-format-columns</v-icon>
        </v-btn> -->
        <v-btn small outlined color="primary" @click="exportFn()">
          <v-icon small left>mdi-file-download-outline</v-icon>
          Export
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <div class="s-data-table">
      <v-row no-gutters>
        <v-col>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="records"
            item-key="name"
            class="elevation-0 records"
            hide-default-footer
            :customSort="customSort"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            must-sort
            fixed-header
            height="calc(100vh - 50px - 70px - 5px)"
            dense
            disable-pagination
            :loading="loading"
            :mobile-breakpoint="0"
          >
            <template v-slot:item.Stock_long_name="{ item }">
              <span class="stock_name" @click="openLink(item.co_code)">{{
                item.Stock_long_name
              }}</span>
            </template>
            <template v-slot:body.append>
              <v-row>
                <v-col class="pb-4 pl-6">
                  <v-btn
                    small
                    outlined
                    color="primary"
                    v-if="showViewMore"
                    @click="viewMore()"
                    :loading="loading"
                  >
                    Load More</v-btn
                  >
                </v-col>
              </v-row>
            </template>
          </v-data-table>
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style>
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  height: 40px;
  font-size: 14px !important;
  font-weight: 600 !important;
  background-color: rgb(249, 250, 252);
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr {
  height: 40px !important;
}

th:first-child,
td:first-child {
  position: sticky;
  left: 0;
  min-width: 230px !important;
  z-index: 2;
  border-right: 1px solid rgba(0, 0, 0, 0.10) !important;
}

th:first-child {
  z-index: 3 !important;
}

td:first-child {
  background-color: #fff !important;
  font-weight: 600;
}

tr:hover {
  background-color:#fbf8e9 !important;;
}
tr:hover > td {
  background-color: inherit !important;
}

td,
th {
  border-right: 1px solid rgba(0, 0, 0, 0.02);
  padding: 8px !important;
  font-size: 16px !important;
}
.stock_name {
  cursor: pointer;
  font-size: 15px !important;
}
.stock_name:hover {
  color: var(--v-primary-base) !important;
  text-decoration: underline;
}
</style>

<script>
export default {
  props: {
    headers: { type: Array, required: true },
    records: { type: Array, required: true },
    showViewMore: Boolean,
    limit: { type: Number, required: true },
    totalCount: { type: Number, required: true },
    loading: { type: Boolean, required: true },
  },
  data() {
    return {
      selected: [],
      sortBy: "Market_cap", // @Todo: set it from report option from server
      sortDesc: true,
    };
  },

  methods: {
    openLink(coCode) {
      const url = `https://primeinvestor.in/stock-details/?co_code=${coCode}`;
      window.open(url, "_blank");
    },
    viewMore() {
      this.$emit("paginate");
    },
    invokeSort() {
      this.$emit("sort", {
        sortKey: this.sortBy,
        sortOrder: this.sortDesc ? 1 : 0,
      });
    },
    exportFn() {
      this.$emit("exportFn");
    },
    customSort(items) {
      return items;
    },
  },
  watch: {
    sortBy() {
      this.invokeSort();
    },
    sortDesc() {
      this.invokeSort();
    },
  },
};
</script>
